export const PAGE_TITLE = "World Happiness";

export const PAGE_TEXT =
  "Matthew J. Brownstein has collaborated with <b>Luis Gallardo</b>, founder of the <b>World Happiness Foundation</b>, to promote global well-being. Gallardo's ambitious goal is to see <b>10 billion people happy by 2050.</b> To align your mind with this vision, we invite you to listen to the recording available by clicking on the image above.<br /><br />The World Happiness Foundation is dedicated to supporting leaders and institutions that contribute to global happiness, encouraging innovation, holistic education, and activism to make happiness accessible to as many people as possible.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/17CRERIbNLQ-Hlu1mdQUem6Xz524YBsYg/preview";

export const SECTION_TITLE =
  "We also encourage you to explore Luis Gallardo's initiatives, including:";

export const FOOTER_TEXT =
  "By engaging with these resources, you can contribute to the global movement towards increased happiness and well-being.";

export const LINK_BOX_TITLE = "World Happiness Foundation";

export const LINK_BOX_URL = "https://worldhappiness.foundation/";

export const YOUTUBE_VIDEO_ID = "MHsE0OHm0og";

export const YOUTUBE_OPTS = {
  height: "390",
  width: "100%",
};

export const HAPPINESS_DATA = [
  {
    id: 1,
    title: "Schools of Happiness",
    text: "These programs nurture educational ecosystems that foster flourishing students, emphasizing the importance of well-being in education. ",
  },
  {
    id: 2,
    title: "World Happiness Fest",
    text: "An annual event that brings together experts and enthusiasts to discuss and promote happiness and well-being worldwide.",
  },
  {
    id: 3,
    title: "Chief Well-Being Officers",
    text: "A program designed to elevate careers by training individuals to become Chief Well-Being Officers, making a global impact by integrating well-being into organizational cultures.",
  },
  {
    id: 4,
    title: "Unlocking the Power of Belonging",
    text: "An initiative focused on fostering trust and belonging to create environments where individuals and societies thrive.",
  },
];
